/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type ModerateSearchBarContainer_story = {
    readonly id: string;
    readonly site: {
        readonly name: string;
        readonly id: string;
    };
    readonly metadata: {
        readonly title: string | null;
        readonly author: string | null;
        readonly section: string | null;
    } | null;
    readonly " $refType": "ModerateSearchBarContainer_story";
};
export type ModerateSearchBarContainer_story$data = ModerateSearchBarContainer_story;
export type ModerateSearchBarContainer_story$key = {
    readonly " $data"?: ModerateSearchBarContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateSearchBarContainer_story">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ModerateSearchBarContainer_story",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Site",
                "kind": "LinkedField",
                "name": "site",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                    },
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "StoryMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "author",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "section",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Story",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'eac256a11eaa110784161760a2c8b447';
export default node;
